import { Button, Pagination, Table } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { Status } from "../../../components/Status"
import { formatDate } from "../../../constant/utils"
import { ContactGAI } from "./ContactGAI"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"
import { getRenewalsAndEmails } from "../../../data/applicationSlice"
import Loader from "../../../components/Loader"
const RenewalsAndEmailsTable = () => {
    const {
        renewalsAndEmails: renewalAndEmails,
        renewalsAndEmailsRecords: totalRecords,
        fetchStatus
    } = useSelector((state) => state.application)

    const [showContactGAI, setShowContactGAI] = useState(false)
    const [selectedRow, setSelectedRow] = useState({})
    const [activePage, setActivePage] = useState(0)

    const numberOfRecordsPerPage = 25
    const totalPages = Math.ceil(totalRecords / numberOfRecordsPerPage)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        getRenewalsAndEmailsList()
    }, [])

    const getRenewalsAndEmailsList = (pageIndex = 1) => {
        return dispatch(
            getRenewalsAndEmails({
                pageIndex,
                numberOfRecords: numberOfRecordsPerPage,
                orderBy: "firstNamedInsured",
                descending: true
            })
        )
    }

    // Function to handle page change
    const handlePageChange = (index) => {
        if (index >= 0) {
            if (index === activePage) return
            setActivePage(index)
            getRenewalsAndEmailsList(index + 1)
        }
    }

    const renderPagination = () => {
        const paginationItems = []
        const ellipsis = (
            <Pagination.Ellipsis
                key="ellipsis"
                disabled
            />
        )
        const pagesToShow = 5 // Number of pages to show in the middle
        const tailPagesToShow = 2 // Number of pages to show at the end

        // Add First and Previous Buttons
        paginationItems.push(
            <Pagination.First
                key="first"
                onClick={() => handlePageChange(0)}
                disabled={activePage === 0}
            />
        )
        paginationItems.push(
            <Pagination.Prev
                key="prev"
                onClick={() => handlePageChange(activePage - 1)}
                disabled={activePage === 0}
            />
        )

        // Add initial pages or ellipsis
        if (activePage > pagesToShow - 1) {
            paginationItems.push(
                <Pagination.Item
                    key={0}
                    onClick={() => handlePageChange(0)}
                    active={activePage === 0}>
                    {1}
                </Pagination.Item>
            )
            paginationItems.push(ellipsis)
        }

        // Add middle pages
        const startPage = Math.max(0, activePage - Math.floor(pagesToShow / 2))
        const endPage = Math.min(totalPages, startPage + pagesToShow)

        for (let i = startPage; i < endPage; i++) {
            paginationItems.push(
                <Pagination.Item
                    key={i}
                    onClick={() => handlePageChange(i)}
                    active={activePage === i}>
                    {i + 1}
                </Pagination.Item>
            )
        }

        // Add ending pages or ellipsis
        if (totalPages - activePage > pagesToShow) {
            paginationItems.push(ellipsis)
            for (let i = totalPages - tailPagesToShow; i < totalPages; i++) {
                paginationItems.push(
                    <Pagination.Item
                        key={i}
                        onClick={() => handlePageChange(i)}
                        active={activePage === i}>
                        {i + 1}
                    </Pagination.Item>
                )
            }
        }

        // Add Next and Last Buttons
        paginationItems.push(
            <Pagination.Next
                key="next"
                onClick={() => handlePageChange(activePage + 1)}
                disabled={activePage === totalPages - 1}
            />
        )
        paginationItems.push(
            <Pagination.Last
                key="last"
                onClick={() => handlePageChange(totalPages - 1)}
                disabled={activePage === totalPages - 1}
            />
        )

        return paginationItems
    }
    return (
        <div>
            <Loader show={fetchStatus === "loading"} />
            <ContactGAI
                show={showContactGAI}
                hide={() => setShowContactGAI(false)}
                selectedRow={selectedRow}
            />
            <div className="pt-3 bg-white">
                <h5 className="ms-3">Renewals and Emails</h5>
                <Table
                    striped
                    bordered
                    hover
                    responsive
                    className="mt-2">
                    <thead>
                        <tr>
                            <th>Customer Number</th>
                            <th>First Named Insured</th>
                            <th>Policy Number</th>
                            <th>Renewal Date at Policy Inception</th>
                            <th>Underwriter Contact Info</th>
                            <th className="icon-column text-center">Create Renewal Application</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renewalAndEmails.map((item, index) => (
                            <tr key={index}>
                                <td>{item?.customerNumber || ""}</td>
                                <td>{item?.firstNamedInsured || ""}</td>
                                <td>{item?.policyNumber || ""}</td>
                                <td>{formatDate(item?.renewalDate)}</td>
                                <td
                                    role="button"
                                    onClick={() => {
                                        setSelectedRow(item)
                                        setShowContactGAI(true)
                                    }}>
                                    {(item?.brokerContactFirstName || "") + " " + (item?.brokerContactLastName || "")}
                                </td>
                                <td className="text-center">
                                    <Button
                                        variant="light"
                                        className="me-2 btn-sm"
                                        onClick={() =>
                                            navigate("/agency/create-application", {
                                                state: { applicationId: item?.id, isRenewal: true }
                                            })
                                        }>
                                        <FontAwesomeIcon icon={byPrefixAndName.fal["arrow-right"]} />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {totalPages > 1 && (
                    <Pagination
                        className="mt-4 d-flex justify-content-end"
                        size="md">
                        {renderPagination()}
                    </Pagination>
                )}
            </div>
        </div>
    )
}

export default RenewalsAndEmailsTable
